import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';
import commonSubFlowDefnFactories from 'edge/quoteandbind/common/config/FlowConfig';
import paFlowDefnFactory from 'conditional?if=quoteandbind_lob&equals=pa!edge/quoteandbind/pa/config/FlowConfig';
import hoFlowDefnFactory from 'conditional?if=quoteandbind_lob&equals=ho!edge/quoteandbind/ho/config/FlowConfig';
import cpFlowDefnFactory from 'conditional?if=quoteandbind_lob&equals=cp!edge/quoteandbind/cp/config/FlowConfig';
import bopFlowDefnFactory from 'conditional?if=quoteandbind_lob&equals=bop!edge/quoteandbind/bop/config/FlowConfig';
import cppFlowDefnFactory from 'conditional?if=quoteandbind_lob&equals=cpp!ama/edge/quoteandbind/cpp/config/FlowConfig';

export default function (flow, AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx, ActionMessageUtil, EventHub) {

    /**
     * Convert object containing flow definitions into object containing sub flows
     * @param {Object} subFlowDefns containing flow definitions
     * @returns {Object}
     */
    function createSubFlowsFromFlowDefns(subFlowDefns) {
        var subFlowsContainer = {};
        Object.keys(subFlowDefns).reduce(function (container, flowDefnKey) {
            container[flowDefnKey] = flow(subFlowDefns[flowDefnKey]);
            return container;
        }, subFlowsContainer);
        return subFlowsContainer;
    }

    var commonSubFlowDefns = commonSubFlowDefnFactories(AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx, ActionMessageUtil, EventHub);

    var globalExits = flow(commonSubFlowDefns.globalExits);
    var availabilityFlow = flow(commonSubFlowDefns.availabilityCheck);
    var needToSaveCheckFlow = flow(commonSubFlowDefns.needToSaveCheck);
    var paFlows = void 0;
    var hoFlows = void 0;
    var cpFlows = void 0;
    var bopFlows = void 0;
    var cppFlows = void 0;

    // if the personal auto feature is enabled then create the PA flow
    if (ApplicationFeatures.hasFeature('quoteandbind_lob.pa')) {
        var paFlowDefns = paFlowDefnFactory(AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx, EventHub);
        paFlows = createSubFlowsFromFlowDefns(paFlowDefns);
    }
    // if the homeowners feature is enabled then create the HO flow
    if (ApplicationFeatures.hasFeature('quoteandbind_lob.ho')) {
        var hoFlowDefns = hoFlowDefnFactory(AvailabilityService, LoadSaveService, $q, TranslateService);
        hoFlows = createSubFlowsFromFlowDefns(hoFlowDefns);
    }
    // if the commercial property feature is enabled then create the CP flow
    if (ApplicationFeatures.hasFeature('quoteandbind_lob.cp')) {
        var cpFlowDefns = cpFlowDefnFactory(AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx, EventHub);
        cpFlows = createSubFlowsFromFlowDefns(cpFlowDefns);
    }
    // if the BOP feature is enabled then create the BOP flow
    if (ApplicationFeatures.hasFeature('quoteandbind_lob.bop')) {
        var bopFlowDefns = bopFlowDefnFactory(AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx, EventHub);
        bopFlows = createSubFlowsFromFlowDefns(bopFlowDefns);
    }
    // if the CPP (AMA) feature is enabled then create the CPP flow
    if (ApplicationFeatures.hasFeature('quoteandbind_lob.cpp')) {
        var cppFlowDefns = cppFlowDefnFactory(AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx, EventHub);
        cppFlows = createSubFlowsFromFlowDefns(cppFlowDefns);
    }
    var quoteFlow = flow(commonSubFlowDefns.quote);
    var bindFlow = flow(commonSubFlowDefns.bindAndPay);

    return {
        exit: globalExits,
        availability: availabilityFlow,
        needToSaveCheck: needToSaveCheckFlow,
        paFlows: paFlows,
        hoFlows: hoFlows,
        cpFlows: cpFlows,
        bopFlows: bopFlows,
        cppFlows: cppFlows,
        quote: quoteFlow,
        bind: bindFlow
    };
}


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/integration/quoteandbind/config/_createSubflowsFromDefns.js
// module id = 866
// module chunks = 0